import { useEffect, useRef, useState } from 'react';
import ChatApi from '../api/ChatApi';

const POLL_INTERVAL_MS = 2 * 60 * 1000; // 2분

/**
 * 안 읽은 채팅 수를 2분마다 폴링. 브라우저 포커스 아웃 시 중단, 복귀 시 즉시 재조회 후 재개.
 *
 * @param {boolean} enabled - 로그인 상태일 때만 true
 */
const useUnreadChatCount = (enabled) => {
    const [unreadChat, setUnreadChat] = useState(0);
    const [openRequests, setOpenRequests] = useState(0);
    const timerRef = useRef(null);

    const fetch = async () => {
        const [chat, req] = await Promise.all([
            ChatApi.getUnreadChatroomCount(),
            ChatApi.getOpenRequestCount(),
        ]);
        setUnreadChat(chat);
        setOpenRequests(req);
    };

    const start = () => {
        if (timerRef.current) return;
        timerRef.current = setInterval(fetch, POLL_INTERVAL_MS);
    };

    const stop = () => {
        clearInterval(timerRef.current);
        timerRef.current = null;
    };

    const handleVisibilityChange = () => {
        if (document.hidden) {
            stop();
        } else {
            fetch();
            start();
        }
    };

    useEffect(() => {
        if (!enabled) {
            stop();
            setUnreadChat(0);
            setOpenRequests(0);
            return;
        }

        fetch();
        start();
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            stop();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [enabled]);

    return { unreadChat, openRequests };
};

export default useUnreadChatCount;
